import { inject, provide, type InjectionKey } from "vue";
import { useSidebarDock } from "@/composables/useSidebarDock";
import { useSidepanelDock } from "@/composables/useSidepanelDock";

interface ShellDocks {
  sidebarDock: ReturnType<typeof useSidebarDock>;
  sidepanelDock: ReturnType<typeof useSidepanelDock>;
}

const shellDocksKey: InjectionKey<ShellDocks> = Symbol("shell-docks");

function createShellDocks(): ShellDocks {
  return {
    sidebarDock: useSidebarDock(),
    sidepanelDock: useSidepanelDock(),
  };
}

export function provideShellDocks(): ShellDocks {
  const docks = createShellDocks();
  provide(shellDocksKey, docks);
  return docks;
}

export function useShellDocks(): ShellDocks {
  return inject(shellDocksKey) ?? createShellDocks();
}
